// MobileBottomNav — fixed bottom navigation bar visible only in mobile mode.
// Renders 5 primary admin destinations as tap targets. Active route gets the
// amber accent.

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, ShoppingBag, Users, Calendar, MessageCircle } from "lucide-react";

const NAV_ITEMS = [
  { label: "Home", icon: Home, path: "/admin", testId: "mobile-nav-home" },
  { label: "Orders", icon: ShoppingBag, path: "/admin/orders", testId: "mobile-nav-orders" },
  { label: "Clients", icon: Users, path: "/admin/clients", testId: "mobile-nav-clients" },
  { label: "Calendar", icon: Calendar, path: "/admin/calendar", testId: "mobile-nav-calendar" },
  { label: "Inbox", icon: MessageCircle, path: "/admin/messages", testId: "mobile-nav-messages" },
];

export const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="mobile-bottom-nav fixed bottom-0 left-0 right-0 z-50 grid grid-cols-5 border-t border-white/10 bg-[#0a1628]/95 backdrop-blur supports-[backdrop-filter]:bg-[#0a1628]/85"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px))" }}
      data-testid="mobile-bottom-nav"
    >
      {NAV_ITEMS.map((item) => {
        const active =
          item.path === "/admin"
            ? location.pathname === "/admin"
            : location.pathname.startsWith(item.path);
        const Icon = item.icon;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className={`flex h-14 flex-col items-center justify-center gap-0.5 transition ${
              active ? "text-amber-400" : "text-slate-400 hover:text-white"
            }`}
            data-testid={item.testId}
          >
            <Icon size={18} />
            <span className="text-[10px] font-medium leading-tight">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
